/**
 * @generated SignedSource<<dda675be1ac3312ec73e8576a050ff05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GnosisSafeAddWalletFragment$data = {
  readonly viewer: {
    readonly user?: {
      readonly wallets: ReadonlyArray<{
        readonly chainAddress: {
          readonly address: string | null;
        };
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ManageWalletsModalFragment">;
  readonly " $fragmentType": "GnosisSafeAddWalletFragment";
};
export type GnosisSafeAddWalletFragment$key = {
  readonly " $data"?: GnosisSafeAddWalletFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"GnosisSafeAddWalletFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GnosisSafeAddWalletFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GalleryUser",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Wallet",
                  "kind": "LinkedField",
                  "name": "wallets",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChainAddress",
                        "kind": "LinkedField",
                        "name": "chainAddress",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "address",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      "action": "NONE",
                      "path": "viewer.user.wallets.chainAddress"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Viewer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ManageWalletsModalFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "83bce414e8dd52d77269b4c68fdc0aa4";

export default node;
